import { createCrestButton, el } from '@bn-games/ui-shell';
import { t } from '../../i18n/I18n.js';
import type { ChessMenuContext, Scene } from '../types.js';

/** The "← Back" row every sub-screen ends with; it leads to the main menu unless told otherwise. */
export function backRow(ctx: ChessMenuContext, to: Scene = 'menu'): HTMLElement {
  return el('div', { class: 'button-row back-button-row' }, [
    createCrestButton({ label: t('common.back'), small: true, onClick: () => ctx.navigate(to) }),
  ]);
}
